import { mtop } from '../../utils/index';
import { message } from 'antd';

export default {
  namespace: 'contract',
  state: {
    agreementsCode: {},
    agreementsContent: '',
    signStatus: false,
    errAgree: 0,
    errSign: 0,
  },
  reducers: {
    setAgreements(state, { payload: agreementsCode }) {
      return {
        ...state,
        agreementsCode,
      };
    },
    setAgreementsContent(state, { payload: agreementsContent }) {
      return {
        ...state,
        agreementsContent,
      };
    },
    setSignStatus(state, { payload: signStatus }) {
      return {
        ...state,
        signStatus,
      };
    },
    setErrAgree(state, { errAgree }) {
      return {
        ...state,
        errAgree,
      };
    },
    setErrSign(state, { errSign }) {
      return {
        ...state,
        errSign,
      };
    },
  },
  effects: {
    // 协议和二维码
    * getAgreements({ payload, reqUrl }, { put, call }) {
      try {
        const response = yield call(mtop, reqUrl, {
          ...payload,
        });
        yield put({ type: 'setAgreements', payload: response });
      } catch (error) {
        message.error(error.msg);
        yield put({ type: 'setAgreements', payload: {} });
      }
    },
    // 协议内容
    * getAgreementsContent({ payload, reqUrl }, { put, call }) {
      try {
        const response = yield call(mtop, reqUrl, {
          ...payload,
        });
        yield put({ type: 'setAgreementsContent', payload: response });
      } catch (error) {
        message.error(error.msg);
        yield put({ type: 'setAgreementsContent', payload: {} });
      }
    },
    // 二维码是否扫描
    * getSignStatus({ payload, reqUrl }, { put, call }) {
      try {
        const response = yield call(mtop, reqUrl, {
          ...payload,
        });
        yield put({ type: 'setSignStatus', payload: {status: response, ...payload} });
      } catch (error) {
        message.error(error.msg);
        yield put({ type: 'setSignStatus', payload: {} });
      }
    },
  },
};



// WEBPACK FOOTER //
// ./src/models/common/contract.js